import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { HashLink } from "react-router-hash-link";
import Metatag from "../../hooks/Metatag";

export default function AboutUs() {
    const [toggler, setToggler] = useState(true);
    const [index, setIndex] = useState(0);

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -134;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    useEffect(() => {
        // add class for home header and remove inner class
        $(".fixed-top").addClass("bg-header");

        // initiate the wow effect
        new WOW.WOW({
            live: false,
        }).init();

        // hotspot

        var $hotspots;

        function init() {
            $hotspots = $('.map-hotspot-icon');
            $('.hs-close').add($hotspots).click(togglePanel);
        }

        function togglePanel(e) {
            //close previously open
            $('.map-hotspot.active').find('.map-reveal').hide();
            var $hotspot = $(e.target).closest('.map-hotspot'),
                $icon = $hotspot.find('.map-hotspot-icon'),
                $panel = $icon.siblings('.map-reveal');
            $('.map-hotspot.active').not($hotspot).removeClass('active');
            $panel.show(function () { });
            $hotspot.toggleClass('active');

            if (!$hotspot.hasClass('active')) {
                $panel.hide();
            }
        }
        $(init);



    }, []);

    return (
        <>
            <Header main_className="bg-header"></Header>

            {/* Metatag */}
            <Metatag title='About The National Disease Modelling Consortium | Objectives of NDMC India | Hub For Disease Modellers in India'  
                    keywords='NDMC by Indian Institute of Technology Bombay, Objectives of NDMC India, Hub For Disease Modellers in India, Studying Impact Of Disease Occurrence In India, Collaborating Disease and System Modelling Experts, Academic Training Programmes For Disease Modelling, Workshops For Disease Modelling, Organise Conferences On Disease Modelling' 
                    description='National Disease Modelling Consortium is established by Indian Institute of Technology Bombay to collaborate range of disease and system modelling experts in India.'
                    />

            <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-about.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
                <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
                <div className="masthead d-flex align-items-center w-100">
                    <Container className="px-4 px-md-5">
                        <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">About Us</h1>
                    </Container>
                </div>
            </Container>

            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                <div className="mb-5" id="objectives">
                    <Row>
                        <Col lg="7" className="pe-4">
                            <div>
                                <h2 className="text-danger fw-bold">
                                    Who We Are
                                </h2>
                                <p>The National Disease Modelling Consortium (NDMC) is a unique national effort to
                                    develop India-specific models of various diseases. Established in 2022, NDMC is
                                    anchored in the Indian Institute of Technology, Bombay, and represents a group
                                    of modellers from across the country. NDMC aims to generate consolidated
                                    estimates of disease burden and the overall effect of vaccination and other
                                    treatment and intervention strategies on the population.</p>

                                <h3 className="text-danger fw-bold mt-5">Purpose</h3>
                                <p>To facilitate collaboration among a wide range of disease and system modelling
                                    experts across the country. NDMC aims to foster learning through collaboration
                                    to improve modelling methodologies, spatial mapping of diseases, optimise
                                    healthcare resource utilisation, and provide strategies to national policymakers
                                    to improve disease control and elimination efforts. </p>
                                <ul>
                                    <li> Disease models help in understanding the spread of diseases through a
                                        population</li>
                                    <li> Spatial mapping helps in identifying disease hotspots and tracking disease
                                        transmission</li>
                                    <li> Economic modelling helps in effective allocation and management of
                                        available resources for disease control</li>
                                </ul>
                                <p>Creating an infrastructure and database where multiple such models can be
                                    generated, aggregated and studied, using this wide network of expertise and
                                    techniques, provides a comprehensive and pioneering approach that is at once
                                    ambitious, effective, and essential.</p>
                            </div>
                        </Col>
                        <Col lg="5" className="pt-xl-0 pt-4">
                            <div className="bg-white ps-xl-5 ms-xl-3 divider-start h-100">
                                <h3 className="text-danger fw-bold">Objectives of the NDMC</h3>
                                <div className="d-sm-flex my-3 align-items-center">
                                    <div className="flex-shrink-1 mb-2 mb-sm-0">
                                        <div className="rounded-3 p-3 icon-grad">
                                            <img loading="lazy" src={global.variables.strDomainUrl + "images/icon-modellers.png"} alt="Create a hub for disease modellers across the country" title="Create a hub for disease modellers across the country" className="img-fluid icon-invert" />
                                        </div>
                                    </div>
                                    <div className="flex-grow-1 ps-sm-4">
                                        Create a hub for disease modellers across the country
                                    </div>
                                </div>

                                <div className="d-sm-flex my-3 align-items-center">
                                    <div className="flex-shrink-1 mb-2 mb-sm-0">
                                        <div className="rounded-3 p-3 icon-grad">
                                            <img loading="lazy" src={global.variables.strDomainUrl + "images/icon-strategies.png"}
                                                alt="Estimate the impact of disease burden and different prevention and/or treatment strategies in the country"
                                                title="Estimate the impact of disease burden and different prevention and/or treatment strategies in the country"
                                                className="img-fluid icon-invert" />
                                        </div>
                                    </div>
                                    <div className="flex-grow-1 ps-sm-4">
                                        Estimate the impact of disease burden and different prevention and/or
                                        treatment strategies in the country
                                    </div>
                                </div>

                                <div className="d-sm-flex my-3 align-items-center">
                                    <div className="flex-shrink-1 mb-2 mb-sm-0">
                                        <div className="rounded-3 p-3 icon-grad">
                                            <img loading="lazy" src={global.variables.strDomainUrl + "images/icon-interventions.png"}
                                                alt="Collaborate with public-health officers and guide disease interventions in focus areas"
                                                title="Collaborate with public-health officers and guide disease interventions in focus areas"
                                                className="img-fluid icon-invert" />
                                        </div>
                                    </div>
                                    <div className="flex-grow-1 ps-sm-4">
                                        Collaborate with public-health officers and guide disease interventions in
                                        focus areas
                                    </div>
                                </div>

                                <div className="d-sm-flex my-3 align-items-center">
                                    <div className="flex-shrink-1 mb-2 mb-sm-0">
                                        <div className="rounded-3 p-3 icon-grad">
                                            <img loading="lazy" src={global.variables.strDomainUrl + "images/icon-training.png"}
                                                alt="Conduct academic training programmes and workshops for future modellers and organise conferences on disease modelling"
                                                title="Conduct academic training programmes and workshops for future modellers and organise conferences on disease modelling"
                                                className="img-fluid icon-invert" />
                                        </div>
                                    </div>
                                    <div className="flex-grow-1 ps-sm-4">
                                        Conduct academic training programmes and workshops for future modellers and
                                        organise conferences on disease modelling
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="bg-gray-light position-relative rounded-3 my-5 position-relative overflow-hidden">
                    <div className="container p-0">
                        <Row>
                            <Col md="12" lg="8" xl="7">
                                <div className="py-md-5 py-4 ps-md-5 ps-4 pe-0">
                                    <h2 className="text-danger fw-bold">What We Do</h2>
                                    <h6 className="text-dark">Our research currently focuses on four disease areas:
                                    </h6>
                                    <ul className="listing list-group list-group-numbered">
                                        <li className="list-group-item px-0 py-1 bg-transparent border-0 fw-semibold">
                                            <Link to={`${global.variables.strDomainUrl}disease/malaria`}>Malaria</Link></li>
                                        <li className="list-group-item px-0 py-1 bg-transparent border-0 fw-semibold">
                                            <Link to={`${global.variables.strDomainUrl}disease/tuberculosis`}>Tuberculosis</Link>
                                        </li>
                                        <li className="list-group-item px-0 py-1 bg-transparent border-0 fw-semibold">
                                            Vaccine Preventable Diseases (VPDs)
                                            <div className="d-md-flex">
                                                <ul className="list fw-normal">
                                                    <li>Diphtheria</li>
                                                    <li>Hepatitis B</li>
                                                    <li>Human papillomavirus</li>
                                                    <li>Japanese encephalitis</li>
                                                </ul>
                                                <ul className="list fw-normal ms-xxl-5 ms-xl-1 ms-0">
                                                    <li><Link to={`${global.variables.strDomainUrl}disease/measles`}>Measles</Link></li>
                                                    <li>Pertussis</li>
                                                    <li>Pneumococcal disease</li>
                                                    <li>Polio</li>
                                                </ul>
                                                <ul className="list fw-normal ms-xxl-5 ms-xl-1 ms-0">
                                                    <li>Tetanus</li>
                                                    <li>Typhoid fever</li>
                                                    <li>Rotavirus</li>
                                                    <li>Rubella</li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li className="list-group-item px-0 py-1 bg-transparent border-0 fw-semibold">
                                            Neglected Tropical Diseases (NTDs)
                                            <ul className="list fw-normal">
                                                <li><Link to={`${global.variables.strDomainUrl}disease/lymphatic-filariasis`} >Lymphatic filariasis</Link></li>
                                                <li><Link to={`${global.variables.strDomainUrl}disease/visceral-leishmaniasis`} scroll={el => scrollWithOffset(el)}>Visceral leishmaniasis (Kala-azar)</Link></li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <p className="mb-0">Our research work aims to inform and influence policy decisions.
                                        Therefore, we work closely with national and global health organisations
                                        including the Ministry and Health and Family Welfare, the Department of
                                        Biotechnology, and the Indian Council of Medical Research.</p>
                                </div>
                            </Col>
                            <Col md="6" lg="4" xl="5" className="d-xl-block d-none position-relative overflow-hidden bg-research"></Col>
                        </Row>

                    </div>
                </div>

                <div className="my-5">
                    <Row className="g-4">
                        <Col md="6">
                            <h2 className="mb-0 fw-bold text-danger">Where We Work</h2>
                            <p className="pb-md-4 ">Click on the dots to view details</p>
                            <div className="map-outer">
                                <div className="map-inner">
                                    <div className="map position-relative">
                                        <img src={global.variables.strDomainUrl + "images/india.svg"} alt="India Map" className="img-fluid" />
                                        <div className="map-hotspots">
                                            <div className="map-hotspot right" style={{ left: "16.5%", top: "62%" }}>
                                                <i data-hotspot="1" className="map-hotspot-icon mumbai wow fadeIn"
                                                    data-wow-delay=".5s"></i>
                                                <div className="map-reveal map-reveal-mumbai right" data-hotspot="1">
                                                    <div className="map-reveal-inner map-reveal-mumbai-inner">
                                                        <div className="hs-close"></div>
                                                        <h4 className="map-title fw-bold text-white mb-2 mt-2">Mumbai
                                                        </h4>
                                                        <ul className="small">
                                                            <li><Link target="_blank" to="https://www.iitb.ac.in/"
                                                                rel="nofollow" className="text-white">Indian
                                                                Institute of Technology Bombay</Link>
                                                            </li>
                                                            <li><Link target="_blank"
                                                                to="https://www.iipsindia.ac.in/"
                                                                rel="nofollow" className="text-white">International
                                                                Institute for Population Sciences</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="map-hotspot right" style={{ left: "31%", top: "30%" }}>
                                                <i data-hotspot="3" className="map-hotspot-icon wow fadeIn"
                                                    data-wow-delay=".7s"></i>
                                                <div className="map-reveal right" data-hotspot="3">
                                                    <div className="map-reveal-inner">
                                                        <div className="hs-close"></div>
                                                        <h4 className="map-title fw-bold text-white mb-2 mt-2">Delhi
                                                        </h4>
                                                        <ul className="small">
                                                            <li><Link target="_blank" to="https://phfi.org/"
                                                                rel="nofollow" className="text-white">Public Health
                                                                Foundation of India
                                                            </Link>
                                                            </li>
                                                            <li><Link target="_blank" to="https://www.aiims.edu/index.php?lang=en"
                                                                rel="nofollow" className="text-white">All India Institute of Medical Sciences</Link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="map-hotspot right" style={{ left: "41%", top: "37.5%" }}>
                                                <i data-hotspot="3" className="map-hotspot-icon wow fadeIn"
                                                    data-wow-delay=".9s"></i>
                                                <div className="map-reveal right" data-hotspot="3">
                                                    <div className="map-reveal-inner">
                                                        <div className="hs-close"></div>
                                                        <h4 className="map-title fw-bold text-white mb-2 mt-2">Kanpur
                                                        </h4>
                                                        <ul className="small">
                                                            <li><Link target="_blank" to="https://www.iitk.ac.in/"
                                                                rel="nofollow" className="text-white">Indian
                                                                Institute of Technology Kanpur</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="map-hotspot right" style={{ left: "31%", top: "80.5%" }}>
                                                <i data-hotspot="2" className="map-hotspot-icon wow fadeIn"
                                                    data-wow-delay="1.1s"></i>
                                                <div className="map-reveal right" data-hotspot="2">
                                                    <div className="map-reveal-inner">
                                                        <div className="hs-close"></div>
                                                        <h4 className="map-title fw-bold text-white mb-2 mt-2">Bengaluru
                                                        </h4>
                                                        <ul className="small">
                                                            <li><Link target="_blank" to="https://iisc.ac.in/"
                                                                rel="nofollow" className="text-white">Indian
                                                                Institute of Science</Link>
                                                            </li>
                                                            <li><Link target="_blank" to="https://www.icts.res.in/"
                                                                rel="nofollow" className="text-white">International
                                                                Centre for Theoretical Sciences
                                                            </Link>
                                                            </li>
                                                            <li><Link target="_blank" to="https://nivedi.res.in/"
                                                                rel="nofollow" className="text-white">ICAR -
                                                                National Institute of Veterinary Epidemiology
                                                                and Disease Informatics</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="map-hotspot right" style={{ left: "41%", top: "81.5%" }}>
                                                <i data-hotspot="3" className="map-hotspot-icon wow fadeIn"
                                                    data-wow-delay="1.3s"></i>
                                                <div className="map-reveal right" data-hotspot="3">
                                                    <div className="map-reveal-inner">
                                                        <div className="hs-close"></div>
                                                        <h4 className="map-title fw-bold text-white mb-2 mt-2">Chennai
                                                        </h4>
                                                        <ul className="small">
                                                            <li><Link target="_blank" to="https://www.iitm.ac.in/"
                                                                rel="nofollow" className="text-white">Indian
                                                                Institute of Technology Madras</Link>
                                                            </li>
                                                            <li><Link target="_blank" to="https://vit.ac.in/"
                                                                rel="nofollow" className="text-white">Vellore
                                                                Institute of Technology</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md="6" className="ps-md-5">
                            <h2 className="mb-0 fw-bold text-danger">Organisation Structure</h2>
                            <img src={global.variables.strDomainUrl + "images/organization-chart.png"} alt="" title="" className="img-fluid" />
                        </Col>
                    </Row>
                </div>

                    
                    <div className="mt-5" id="whyiitb">
                        <Row className="position-relative bg-light rounded-3 p-md-5 p-4">
                            <Col lg="5" className="position-relative">
                                <div className="pic-border mb-lg-0 mb-4 wow fadeInDown">
                                    <img src={global.variables.strDomainUrl + "images/pic-iit-bombay.jpg"} className="img-fluid rounded-3"
                                        alt="Indian Institute of Technology Bombay (IIT)"
                                        title="Indian Institute of Technology Bombay (IIT)"/>
                                </div>
                            </Col>
                            <Col lg="7" className="data-border d-flex align-items-center wow fadeInUp">
                                <div className="border-content px-lg-4">
                                    <h2 className="text-danger fw-bold">Why Indian Institute of Technology Bombay?</h2>
                                    <p className="m-0"><Link to="https://www.iitb.ac.in/" target="_blank"
                                            rel="nofollow">Indian Institute of Technology (IIT) Bombay</Link> consistently
                                        ranks as one
                                        of the top universities in the country and among the best in the world. The
                                        Institute has
                                        been declared as an <i>Institution of Eminence</i> by the Ministry of Human
                                        Resource
                                        Development, Government of India. With its status as an <i>Institute of
                                            Eminence</i>,
                                        IIT Bombay aims to achieve social impact by engaging in cutting edge applied
                                        research and innovation. <Link to="https://www.kcdh.iitb.ac.in/" target="_blank"
                                            rel="nofollow">The Koita Centre for Digital Health</Link> at IIT Bombay was
                                        recently established to promote academic programs, research, and industry
                                        collaborations in Digital Health. IIT Bombay faculty across departments are
                                        specialised in the areas necessary for disease modelling. This essential
                                        combination of vision, infrastructure, and expertise, makes IIT Bombay the ideal
                                        platform for leading the NDMC.</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                
        </Container >
  
  
        {/* Breadcrumb */}
        <Container Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
          <Breadcrumb>
            <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>About Us</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
        {/* Breadcrumb */}
      </>
    );
}